import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

export const hostCommerceApi = {
  /** Host 收益與商務歷程（GET，需登入；hostMemberId 由後端 token 決定） */
  history: (params) => travelClient.get(travelEndpoints.commerceHistory, { params }),
};
